import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Dataset from 'components/NextconLabDatasets/Dataset';
import { useEffect } from "react";

function Fcontact() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Dataset/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Dataset/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Fcontact;
